export const getSafeRedirectPath = (
  redirectUrl: unknown,
  origin: string,
  fallback: string,
): string => {
  if (typeof redirectUrl !== 'string' || redirectUrl === '') return fallback;

  try {
    const url = new URL(redirectUrl, origin);
    if (url.origin !== origin) return fallback;
    const path = `${url.pathname}${url.search}${url.hash}`;
    // a same-origin URL can still have a pathname like `//evil.com`, which is protocol-relative once used on its own
    if (new URL(path, origin).origin !== origin) return fallback;
    return path;
  } catch {
    return fallback;
  }
};
